var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-badge"},[_c('div',[_c('a',{staticClass:"badge-install btn btn-sm role-secondary",attrs:{"data-testid":"add-custom-cluster-badge"},on:{"click":_vm.customBadgeDialog}},[_c('i',{directives:[{name:"clean-tooltip",rawName:"v-clean-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"icon icon-brush-icon"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }